import CommunicationPreviewComponent from '../component/CommunicationPreviewComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  communicationViewFetch,
  communicationListSegmentsFetch,
  communicationListSmsChannelsFetch,
  communicationListPushChannelsFetch,
  communicationListEmailChannelsFetch,
  communicationListEventsFetch,
  communicationListTriggerEventsFetch,
  communicationRevalidateTriggerEventFetch,
  communicationLaunchFetch,
  communicationListTagsFetch,
  communicationListCustomChannelsFetch,
  whatsappChannelTemplateViewFetch,
  communicationListTelegramChannelsFetch,
  communicationPreviewFetch,
} from '../CommunicationActions';
import PropTypes from 'prop-types';

const mapStateToProps = (state) => ({
  currentCommunication: state.engage.communication.currentCommunication,
  loadingView: state.engage.communication.loadingView,
  loadingSegment: state.engage.communication.loadingSegment,
  segments: state.engage.communication.segments,
  loadingEvents: state.engage.communication.loadingEvents,
  loadingSmsChannels: state.engage.communication.loadingSmsChannels,
  loadingPushChannels: state.engage.communication.loadingPushChannels,
  loadingEmailChannels: state.engage.communication.loadingEmailChannels,
  communicationData: state.engage.communication.communicationData,
  loadingLaunch: state.engage.communication.loadingLaunch,
  emailChannels: state.engage.communication.emailChannels,
  pushChannels: state.engage.communication.pushChannels,
  smsChannels: state.engage.communication.smsChannels,
  telegramChannels: state.engage.communication.telegramChannels,
  customChannels: state.engage.communication.customChannels,
  eventList: state.engage.communication.eventList,
  triggerEventList: state.engage.communication.triggerEventList,
  loadingTriggerEvents: state.engage.communication.loadingTriggerEvents,
  errorTriggerEvents: state.engage.communication.errorTriggerEvents,
  loadingListTags: state.engage.communication.loadingListTags,
  listTags: state.engage.communication.listTags,
  pathname: state.router.location.pathname,
  userProducts: state.account.auth.currentUser.products,
  whatsAppTemplateObject: state.engage.communication.whatsAppTemplateObject,
  communicationPreview: state.engage.communication.communicationPreview,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      communicationViewFetch,
      communicationListSegmentsFetch,
      communicationListSmsChannelsFetch,
      communicationListTelegramChannelsFetch,
      communicationListPushChannelsFetch,
      communicationListEmailChannelsFetch,
      communicationListEventsFetch,
      communicationListTriggerEventsFetch,
      communicationRevalidateTriggerEventFetch,
      communicationLaunchFetch,
      communicationListTagsFetch,
      communicationListCustomChannelsFetch,
      whatsappChannelTemplateViewFetch,
      communicationPreviewFetch,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunicationPreviewComponent);

CommunicationPreviewComponent.propTypes = {
  page: PropTypes.object.isRequired,
  pageRequest: PropTypes.object.isRequired,
  communicationViewFetch: PropTypes.func.isRequired,
};
